import { render, staticRenderFns } from "./install-page.vue?vue&type=template&id=d3571c88&scoped=true&"
import script from "./install-page.vue?vue&type=script&lang=js&"
export * from "./install-page.vue?vue&type=script&lang=js&"
import style0 from "./install-page.vue?vue&type=style&index=0&id=d3571c88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3571c88",
  null
  
)

export default component.exports